import { withRouter } from 'react-router-dom'
import React from 'react'
import { withProps } from 'recompose'

import { getTrack } from '../app/selectors'
import TrackLine from './TrackLine'
import content from '../content'

// TODO - consider using: https://github.com/rcdexta/react-event-timeline

const TrackPage = ({ track }) => {
  if (!track) {
    return null
  }
  return <TrackLine tracks={[track]} />
}

const withPageContent = withProps(ownProps => ({
  track: getTrack(content, ownProps.match.params.id),
}))

export default withPageContent(withRouter(TrackPage))



// WEBPACK FOOTER //
// ./src/containers/TrackPage.js